export type AnnouncementTelegramType = "manuel" | "automatique";

export const useAddAnnouncementTelegram = () => {
  const runTimeConfig = useRuntimeConfig();
  const userToken = useCookie<string | null>("userToken");

  const sendAddAnnouncementTelegram = async (type: AnnouncementTelegramType) => {
    try {
      const headers = userToken.value
        ? { Authorization: `Bearer ${userToken.value}` }
        : {};

      await $fetch("/announcements/addAnnouncementTelegram", {
        method: "POST",
        headers,
        body: { type },
        baseURL: runTimeConfig.public.baseUrl,
      });
    } catch (error) {
      // console.log(error);
    }
  };

  return {
    sendAddAnnouncementTelegram,
  };
};
